module.exports = __webpack_public_path__ + "static/media/user-grey.5866a62c.svg";